<template>
    <section class="online-survey">
        <div>
            <el-radio-group v-model="tabPosition" style="margin: 10px 0px;">
                <el-radio-button label="top">问卷收集</el-radio-button>
                <el-radio-button label="right">问卷设计</el-radio-button>
            </el-radio-group>
        </div>
        <div v-if="tabPosition === 'top'">
            <div class="form-search-container bg-white ">
                <el-form :model="form" inline size="small" style="padding-left: 20px;display: flex;">
                    <el-form-item>
                        <el-input v-model="form.keyword" placeholder="请输入合同编号/租户名称/房源名称搜索" clearable/>
                    </el-form-item>
                    <!-- <div style="display:flex;align-items: center;margin-bottom:10px"> -->
                    <el-form-item >
                        <el-date-picker v-model="StartAndendTime" type="daterange" range-separator="至" start-placeholder="提交开始时间"
                            style="margin: 0 7px;width: 350px;" end-placeholder="提交结束时间" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"/>
                    </el-form-item>

                    <!-- </div> -->
                    <el-form-item>
                        <el-button type="primary" @click="handleSearchForm">查询</el-button>
                        <el-button @click="handleReset">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="table-container bg-white">
                <r-e-table ref="formTableRef" :dataRequest="getLeasorFeedbackListTableData" :columns="LeasortableColumn" :query="form" :height="735" >
                    <el-table-column slot="toolbar" label="操作" width="200">
                        <template slot-scope="{ row }">
                            <div class="table-tools">
                                <span class="table-btn" @click="handleDetails(row,)" >
                                    详情
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </r-e-table>
            </div>
        </div>
        <div v-if="tabPosition === 'right'">
            <div class="form-search-container bg-white ">
                <!-- <el-button type="primary" @click="handleAddEditCommunity('add', { type: 0 })" size="small"
                        icon="el-icon-plus" class="add">
                    新增小区
                </el-button> -->
                <el-form :model="formSearch" inline size="small" style="padding-left: 20px;">
                    <el-form-item>
                        <el-input v-model="formSearch.keyword" placeholder="请输入小区名称搜索" clearable/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">查询</el-button>
                        <el-button @click="handleReset">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                            <el-button type="primary" @click="handleSurvey('add',{},0)" size="small" class="add">
                    新增问卷
                </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="table-container bg-white">
                <r-e-table ref="communityTableRef" :dataRequest="getCommunityTableData" :afterDataReq="afterDataReq" 
                        :columns="tableColumn" :query="formSearch" :height="735" >
                    <el-table-column slot="toolbar" label="操作" width="200">
                        <template slot-scope="{ row }">
                            <div class="table-tools">
                                <!-- <span  class="table-btn" @click="handleAddEditCommunity('edit', row)">修改</span> -->
                                <span v-if="row.addName === '楼幢' && getButtonMenu('ZUJINFANGSHI') " class="table-btn" @click="handleAddEditUnitPrice(row)">租金方式</span>
                                <span v-if="row.children && row.addName === '模块'" class="table-btn" 
                                    @click="handleSurvey('add', row , 1)">新增{{ row.addName }}</span>
                                                                <!-- <span  class="table-btn" 
                                    @click="handleSurvey('add', row , 1)">新增模块</span> -->
                                <span v-if="row.children && row.addName === '题目'" class="table-btn" 
                                    @click="handleSurvey('add', row , 2)">新增{{ row.addName }}</span>
                                <span v-if="row.children && row.addName === '答案' && row.topicType !== 801303" class="table-btn" 
                                    @click="handleSurvey('add', row , 3)">新增{{ row.addName }}</span>
                                <!-- <span class="table-btn" @click="handleAddEditCommunity('edit', row)"> -->
                                <span class="table-btn" @click="handleSurvey('edit', row,0)" v-if="row.addNames === '问卷'">
                                    修改{{row.addNames }}
                                </span>
                                <span class="table-btn" @click="handleSurvey('edit', row,1)" v-if="row.addNames === '模块'">
                                    修改{{row.addNames }}
                                </span>
                                <span class="table-btn" @click="handleSurvey('edit', row,2)" v-if="row.addNames === '题目'">
                                    修改{{row.addNames }}
                                </span>
                                <span class="table-btn" @click="handleSurvey('edit', row,3)" v-if="row.addNames === '答案'">
                                    修改{{row.addNames }}
                                </span>
                                <span class="table-btn" @click="handleDetails(row,)" v-if="row.children && row.addName === '模块'">
                                    详情
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </r-e-table>
            </div>
        </div>
<!--      -->
        <!--   添加、修改小区弹框       -->
        <layer-add-edit-community class="layer-add-edit-community" ref="communityRef"/>
        <!--   添加、修改楼幢或单元弹框   -->
        <layer-add-edit-building class="layer-add-edit-building" ref="buildingRef"/>
        <!--   编辑单价   -->
        <layer-add-edit-unit-price ref="layerAddEditUnitPrice" @handleSearch="handleSearch"/>
        <!-- 弹窗：新增/修改 问卷 -->
        <layer-survey-dialog ref="layerSurveyDialog" @handleSearch="handleSearch"></layer-survey-dialog>
        <!-- 弹窗：新增/修改 模块 -->
        <layer-section-dialog  ref="layerSectionDialog" @handleSearch="handleSearch"></layer-section-dialog>
        <!-- 弹窗：新增/修改 题目 -->
        <layer-question-dialog  ref="layerQuestionDialog" @handleSearch="handleSearch"></layer-question-dialog>
        <!-- 弹窗：新增/修改 答案 -->
        <layer-answer-dialog  ref="layerAnswerDialog" @handleSearch="handleSearch"></layer-answer-dialog>
        
        
    </section>
</template>

<script>
import {tableColumn,LeasortableColumn} from "./data";
import {layerAddEditCommunity, layerAddEditBuilding,} from "@/views/rental-management/community-management/components";
import {communityAllExport} from "@/api/community-management";
import {timeFormat} from "@custom/index";
import {downloadByData} from "@/utils/hooks/download";
import {buttonCookies} from "@storage/cookies";
import layerSurveyDialog from './components/layer-survey-dialog.vue';
import layerSectionDialog from "./components/layer-section-dialog.vue"
import layerQuestionDialog from "./components/layer-question-dialog.vue";
import layerAnswerDialog from "./components/layer-answer-dialog.vue";
import { LeasorFeedbackListGET } from "@/api/online-survey";

export default {
    name: "online-survey",
    data() {
        return {
            tabPosition: 'top',
            tableColumn,
            LeasortableColumn,
            formSearch: {
                keyword: null,
            },
            form: {
                keyword: null,      // 合同编号
                startTime: null,       // 开始日期
                endTime: null,         // 结束日期
            },
            StartAndendTime: [],       // 日期范围选择器绑定值
            loadingOptions: {
                lock: true,
                text: "Loading...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            },
        };
    },
    components: {
        layerAddEditCommunity,
        layerAddEditBuilding,
        layerSurveyDialog,
        layerSectionDialog,
        layerQuestionDialog,
        layerAnswerDialog,
        layerAddEditUnitPrice: () => import("./components/layer-add-edit-unit-price"),
        
    },
    created() {
        let {params: {data},} = this.$route;
        if (data) {
            const {name} = data;
            if (name) this.formSearch.keyword = name;
        }
        // 使用 nextTick 确保组件已挂载后再获取数据
        this.$nextTick(() => {
            // 根据当前 tab 只加载对应的表格数据
            this.loadCurrentTabData();
        });
    },
    watch: {
        // 监听日期范围选择器的变化，同步到 form 中
        StartAndendTime(val) {
            if (val && val.length === 2) {
                this.form.startTime = val[0];
                this.form.endTime = val[1];
            } else {
                this.form.startTime = null;
                this.form.endTime = null;
            }
        },
        // 监听 tab 切换，加载对应表格数据
        tabPosition(newVal) {
            this.$nextTick(() => {
                this.loadCurrentTabData();
            });
        }
    },
    methods: {
        // 加载当前 tab 对应的表格数据
        loadCurrentTabData() {
            if (this.tabPosition === 'top') {
                // 问卷收集 tab
                if (this.$refs.formTableRef) {
                    this.$refs.formTableRef.getTableData();
                }
            } else if (this.tabPosition === 'right') {
                // 问卷设计 tab
                if (this.$refs.communityTableRef) {
                    this.$refs.communityTableRef.getTableData();
                }
            }
        },
        // 获取小区+楼栋+单元列表
        getCommunityTableData(params) {
            // 获取小区+楼栋+单元列表
            return this.$store.dispatch("community/GetSurveyListActions", params);
        },
        getLeasorFeedbackListTableData(params) {
        // 新接口
         return LeasorFeedbackListGET(params);
        },
        // 获取问卷收集列表
        afterDataReq(e) {
            // 新增按钮修改提示名称
            e.forEach((v) => {
                v.addName = "模块";
                v.addNames = "问卷";
                v.children.forEach((v) => {
                    v.addName = "题目";
                    v.addNames = "模块";
                    v.children.forEach((v) => {
                        v.addName = "答案";
                        v.addNames = "题目";
                         v.children.forEach((v) => {
                            v.addNames = "答案";
                        });
                    });
                });
            });
        },
        // 搜索
        handleSearch() {
            this.$refs.communityTableRef.getTableData();
        },
                // 搜索
        handleSearchForm() {
            this.$refs.formTableRef.getTableData();
        },
        // 重置
        handleReset() {
            // 重置问卷设计的搜索条件
            this.formSearch.keyword = null;
            
            // 重置问卷收集的搜索条件
            this.form.keyword = null;
            this.form.tenantName = null;
            this.form.houseName = null;
            this.StartAndendTime = [];
            this.form.startTime = null;
            this.form.endTime = null;
            
            // 根据当前 tab 刷新对应的表格
            if (this.tabPosition === 'top') {
                this.handleSearchForm();
            } else {
                this.handleSearch();
            }
        },

        // 新增、编辑打开小区、楼幢或单元弹窗
        handleAddEditCommunity(addEdit, row) {
          console.log(row)
            const {type = 0} = row;
            // 新增、编辑打开小区弹窗
            if ((type === 0 && addEdit === "add") || (type === 1 && addEdit === "edit")) {
                this.$refs.communityRef.layerAddEditCommunityInit(addEdit, row);
            } else {
                // 新增、编辑打开楼幢或单元弹窗
                this.$refs.buildingRef.layerAddEditBuildingInit(addEdit, row);
            }
        },

        //打开编辑单价弹窗
        handleAddEditUnitPrice(data) {
            this.$refs["layerAddEditUnitPrice"].openDialog(data);
        },
      getButtonMenu(menu){
        return JSON.parse(buttonCookies.get()).map(item=>item.url).some(v => v === menu);
      },

        // 导出数据
        communityExport() {
            let that = this;
            const loadingOptions = that.loadingOptions;
            const loading = that.$loading({...loadingOptions});
            communityAllExport().then((res) => {
                downloadByData({data: res, filename: `小区管理${timeFormat(new Date(), "yyyy-MM-dd-HH-mm-ss")}.xlsx`});
            }).finally(() => loading.close());
        },
        // 弹窗/新增/修改
        handleSurvey(type,row,num){
            console.log('type',type);   
            console.log('num',num);
             if(num === 0){
                this.$refs["layerSurveyDialog"].openDialog(type,row);
             }else if(num === 1)   {
                this.$refs["layerSectionDialog"].openDialog(type,row);
             }else if(num === 2)   {
                this.$refs["layerQuestionDialog"].openDialog(type,row);
             }else if(num === 3)   {
                this.$refs["layerAnswerDialog"].openDialog(type,row);
             }

        },
        // 详情
        handleDetails(row){
            // 根据当前 tab 决定传递的参数
            let rowData = { ...row };
            
            if (this.tabPosition === 'top') {
                // 问卷收集 tab：标记来源
                rowData._fromTab = 'collection';
                // 保存原始 uuid 用于 leasorSurveyInfo 回显
                rowData._originalUuid = row.uuid;
                // 使用 backFormUuid 作为查询接口的 uuid
                if (row.backFormUuid) {
                    rowData.uuid = row.backFormUuid;
                }
            } else {
                // 问卷设计 tab：标记来源，使用原始的 uuid
                rowData._fromTab = 'design';
            }
            
            this.$router.push({
                name: 'survey-questionnaire-details',
                params: { rowData: rowData }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.online-survey {
    padding: 15px;

    .form-search-container {
        padding-top: VH(20px);
        margin-bottom: VH(15px);

        /deep/ .el-form {
            .el-form-item .el-input__inner {
                width: VW(250px);
            }
        }
    }

    .add {
        position: absolute;
        left: VW(40px);
    }
}
</style>
